import axios from 'axios';

/**
 * Get VONQ getProductsSupportingContracts
 * @returns 
 */
export async function getProductsSupportingContracts({filters = "", userId}) {
    const { data } = await axios.get(`/vonq/${userId}/getProductsSupportingContracts/?${filters}`);
    return data;
}

/**
 * Get VONQ getProductsSupportingContracts
 * @returns 
 */
export async function getProductSupportingContracts({channelId, userId}) {
    const { data } = await axios.get(`/vonq/${userId}/getProductSupportingContracts/${channelId}`);
    return data;
}

/**
 * Get VONQ getProductsSupportingContracts
 * @returns 
 */
export async function searchProducts({filters = "", userId}) {
    const { data } = await axios.get(`/vonq/${userId}/searchProducts/?${filters}`);
    return data;
}


/**
 * Get VONQ getProductsSupportingContracts
 * @returns 
 */
export async function getProducts({userId}) {
    const { data } = await axios.get(`/vonq/${userId}/getProducts`);
    return data;
}


/**
 * Get VONQ getProductsSupportingContracts
 * @returns 
 */
export async function getTaxonomyIndustries({userId}) {
    const { data } = await axios.get(`/vonq/${userId}/taxonomy/industries`);
    return data;
}


/**
 * Get VONQ getProductsSupportingContracts
 * @returns 
 */
export async function getTaxonomyJobFunctions({userId}) {
    const { data } = await axios.get(`/vonq/${userId}/taxonomy/jobFunctions`);
    return data;
}



/**
 * Get VONQ getProductsSupportingContracts
 * @returns 
 */
export async function getTaxonomyJobtitles({userId, filters}) {
    const { data } = await axios.get(`/vonq/${userId}/taxonomy/jobTitles/?${filters}`);
    return data;
}



/**
 * Get VONQ getProductsSupportingContracts
 * @returns 
 */
export async function getTaxonomyLocations({userId, filters}) {
    const { data } = await axios.get(`/vonq/${userId}/taxonomy/locations/?${filters}`);
    return data;
}

/**
 * Get VONQ getTaxonomyEducationLevels
 * @param userId
 * @returns {Promise<any>}
 */
export async function getTaxonomyEducationLevels({userId}) {
    const { data } = await axios.get(`/vonq/${userId}/taxonomy/educationLevels`);
    return data;
}

/**
 * Get VONQ getTaxonomySeniority
 * @param userId
 * @returns {Promise<any>}
 */
export async function getTaxonomySeniority({userId}) {
    const { data } = await axios.get(`/vonq/${userId}/taxonomy/seniority`);
    return data;
}



/**
 * Get VONQ getProductsSupportingContracts
 * @returns 
 */
export async function getProductTypes({userId}) {
    const { data } = await axios.get(`/vonq/${userId}/taxonomy/productTypes`);
    return data;
}